import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Card, Container, Table} from 'react-bootstrap';
import Sidebar from './Sidebar';
import {
  getMainConfig,
  updateMainConfig,
  getBannerLinks,
  getFooterLinks,
  updateBannerLink,
  updateFooterLink,
  deleteBannerLink,
  addBannerLinks,
  getPageContent,
  updatePageContent
} from './apiCalls';
import configAdmin from './configAdmin.json';
import ToastConfirmation from './ToastConfirmation';

export default function MainEdit() {

  const { HOMEPAGE_CODE } = configAdmin
  const STORAGE_CONFIG = `config/${window.REACT_APP_WEB_FOLDER || ""}`;
  
  const [showToaster, setShowToaster] = useState(false);
  const [mainConfig, setMainConfig] = useState({});
  const [homeConfig, setHomeConfig] = useState([]);
  const [bannerLinks, setBannerLinks] = useState([]);
  const [footerLinks, setFooterLinks] = useState([]);
  const [mainConfigformData, setMainConfigformData] = useState({});
  const [homeConfigformData, setHomeConfigformData] = useState({});
  const [bannerLinksformData, setBannerLinksformData] = useState({});
  const [footerLinksformData, setFooterLinksformData] = useState({});

  useEffect(() => {
    getMainConfig(setMainConfig);
    getPageContent(setHomeConfig, HOMEPAGE_CODE);
    getBannerLinks(setBannerLinks);
    getFooterLinks(setFooterLinks);
  }, []);

  useEffect(() => {
    const tempDbAlias = mainConfig?.dbAlias && mainConfig.dbAlias;
    
    tempDbAlias ? setMainConfigformData({dbAlias: tempDbAlias}) : setMainConfigformData({dbAlias: []});

  }, [mainConfig]);

  const submitForm = () => {

    // Update main config

    let mainConfigformDataSubmit = mainConfig;

    mainConfigformDataSubmit = {
      ...mainConfigformDataSubmit,
      ...mainConfigformData
    }

    // order DAM - DAMI - DAME
    if (
      mainConfigformDataSubmit.enabledDA.includes('DAM') &&
      mainConfigformDataSubmit.enabledDA.includes('DAME') &&
      mainConfigformDataSubmit.enabledDA.includes('DAMI')
    ) {
      mainConfigformDataSubmit.enabledDA = ['DAM', 'DAMI', 'DAME']
    } else if (
      mainConfigformDataSubmit.enabledDA.includes('DAME') &&
      mainConfigformDataSubmit.enabledDA.includes('DAMI')
    ) {
      mainConfigformDataSubmit.enabledDA = ['DAMI', 'DAME']
    } else {
      mainConfigformDataSubmit.enabledDA = mainConfigformDataSubmit.enabledDA.sort()
    }

    mainConfigformDataSubmit.enabledDA = JSON.stringify(mainConfigformDataSubmit.enabledDA);

    updateMainConfig(mainConfigformDataSubmit)
      .then(() => {
        getMainConfig(setMainConfig);
        getMainConfig((data) => {
          localStorage.setItem(STORAGE_CONFIG, JSON.stringify(data));
        });
      });

    // Update HOME config
    let homeConfigformDataSubmit = homeConfig;

    homeConfigformDataSubmit = {
      ...homeConfigformDataSubmit,
      ...homeConfigformData
    }
    
    updatePageContent(homeConfigformDataSubmit, HOMEPAGE_CODE);

    setShowToaster(true);
  }

  const saveBannerLink = (id) => {
    bannerLinksformData.hasOwnProperty(id) && updateBannerLink(id, bannerLinksformData[id]);
    setShowToaster(true);
  }

  const saveFooterLink = (id) => {
    footerLinksformData.hasOwnProperty(id) && updateFooterLink(id, footerLinksformData[id]);
    setShowToaster(true);
  }

  const handleDeleteBannerLink = (id) => {
    deleteBannerLink(id);
    setBannerLinks([
      ...bannerLinks.filter((itemLink) => {
        return itemLink.id !== id
      })
    ]);

    // filter keys and let every key distinct to id
    setBannerLinksformData(
      Object.keys(bannerLinksformData)
        .filter(key => key !== id)
        .reduce((obj, key) => {
          return {
            ...obj,
            [key]: bannerLinksformData[key]
          };
        }, {})
    );
    setShowToaster(true);
  }

  const handleAddBannerLinks = () => {
    addBannerLinks([{
      "link_type":"banner",
      "url":"URL",
      "title":"TITULO DE LINK",
      "hidden":false
    }])
      .then(getBannerLinks(setBannerLinks));
  }

  const handleDeleteDB = (id) => {
    let tempDbAlias = mainConfigformData.dbAlias;
    tempDbAlias.splice(id, 1);
    
    setMainConfigformData({
      ...mainConfigformData,
      dbAlias: tempDbAlias
    });
  };

  const handleAddDB = () => {
    setMainConfigformData({
      ...mainConfigformData,
      dbAlias: [...mainConfigformData.dbAlias, {
        'name': 'codigoBaseDeDatosRedatam',
        'label': 'Nombre de base de datos',
        'enabledMigration': false,
        'enabledMobility': false,
        'enabledSegregation': false
      }]
    });
  };


  const modulesList = [
    {'value': 'enabledMigration', 'label': 'Migración'},
    {'value': 'enabledMobility', 'label': 'Movilidad'},
    {'value': 'enabledSegregation', 'label': 'Segregación'},
  ];

  const colorThemes = {
    'green': 'Verde',
    'green-2': 'Verde (2)',
    'coffe': 'Café',
    'red': 'Rojo',
    'blue': 'Azul',
    'light-blue': 'Celeste'
  }

  const formContent = (
    <>
    <Form>
      <Form.Group className="admin-content-group">
        <Form.Label className="admin-content-form-label">Título de página</Form.Label>
        <Form.Control
          placeholder="Titulo"
          defaultValue={ mainConfig?.pageTitle && mainConfig.pageTitle }
          onChange={ (e) => {
            setMainConfigformData({
              ...mainConfigformData,
              pageTitle: e.target.value
            });
          } }  
        />
        <Form.Label className="admin-content-form-label">Subtítulo grande</Form.Label>
        <Form.Control
          placeholder="Subtítulo grande"
          defaultValue={ mainConfig?.pageSubtitle && mainConfig.pageSubtitle }
          onChange={ (e) => {
            setMainConfigformData({
              ...mainConfigformData,
              pageSubtitle: e.target.value
            });
          } }  
        />

        <Form.Label className="admin-content-form-label">Subtítulo pequeño</Form.Label>
        <Form.Control
          placeholder="Subtítulo pequeño"
          defaultValue={ mainConfig?.pageSubSubtitle && mainConfig.pageSubSubtitle }
          onChange={ (e) => {
            setMainConfigformData({
              ...mainConfigformData,
              pageSubSubtitle: e.target.value
            });
          } }  
        />

        <Form.Label className="admin-content-form-label">Título de Banner (Home)</Form.Label>
        <Form.Control
          placeholder="Título de Banner"
          defaultValue={ homeConfig?.title && homeConfig.title }
          onChange={ (e) => {
            setHomeConfigformData({
              ...homeConfigformData,
              title: e.target.value
            });
          } }  
        />

        <Form.Label className="admin-content-form-label">Tema de colores</Form.Label>
        <Form.Select
            id="edit-alias"
            name="alias"
            onChange={ (e) => {
              setMainConfigformData({
                ...mainConfigformData,
                theme: e.target.value
              });
            } }  
          >
            <option defaultValue="selected" key={1} value={ mainConfig.theme }>{ colorThemes[mainConfig.theme] }</option>
            { mainConfig?.theme && Object.keys(colorThemes).filter((item) => item !== mainConfig.theme).map((item, itemId) => <option defaultValue={item === mainConfig.theme ? "mainConfig.theme" : "mainConfig.theme"} key={ itemId } value={ item }>{ colorThemes[item] }</option>) }
        </Form.Select>

        <Form.Label className="admin-content-form-label">Enlace de institución (logo)</Form.Label>
        <Form.Control
          placeholder="https://URL"
          defaultValue={ mainConfig?.logoLink && mainConfig.logoLink }
          onChange={ (e) => {
            setMainConfigformData({
              ...mainConfigformData,
              logoLink: e.target.value
            });
          } }  
        />

        </Form.Group>
        <Button _type="submit" className="odisea-form-button-submit" onClick={() => {submitForm();}}>Guardar configuración</Button>
      </Form>
    </>
  )

  const DAFormContent = [
    {'value': 'DAM', 'label': 'Habilitar DAM'},
    {'value': 'DAMI', 'label': 'Habilitar DAMI'},
    {'value': 'DAME', 'label': 'Habilitar DAME'},
  ];

  const DASection = (
    <Form>
      <Form.Group className="admin-content-group">
        {DAFormContent.map((item, itemId) => 
          <Form.Check
            id= { itemId }
            type = 'switch'
            label={ item.label }
            value={ item.value }
            defaultChecked = {mainConfig && mainConfig?.enabledDA && mainConfig.enabledDA.includes(item.value)}
            checked = {mainConfig && mainConfig?.enabledDA && mainConfig.enabledDA.includes(item.value)}
            onChange={ (e) => {
              let enabledDA = []
              if (mainConfig.hasOwnProperty('enabledDA')) {
                enabledDA = mainConfig.enabledDA;
              }
              if (e.target.checked){
                setMainConfig({
                  ...mainConfig,
                  enabledDA: [...enabledDA, e.target.value]
                });
              } else {
                setMainConfig({
                  ...mainConfig,
                  enabledDA: enabledDA.filter(item => item !== e.target.value)
                });
              }
            }}
          />
        )}
      </Form.Group>
      <br/>
      <Form.Group className="admin-content-group">
        {/* JSON.stringify() */}
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Unidad Territorial</th>
              <th>Nombre</th>
            </tr>
          </thead>
          <tbody>
            {
              mainConfig?.DALabels && Object.keys(mainConfig.DALabels).map((key, itemId) => {
                return (
                  <tr>
                    <td>{itemId + 1}</td>
                    <td> { key } </td>
                    <td>
                      <Form.Control
                        placeholder="Unidad Territorial"
                        defaultValue={ mainConfig?.DALabels && mainConfig.DALabels[key] }
                        onChange={ (e) => {
                          let tmpDALabels = {...mainConfig.DALabels};
                          tmpDALabels = {...tmpDALabels, ...mainConfigformData.DALabels};
                          tmpDALabels[key] = e.target.value;
                          setMainConfigformData({
                            ...mainConfigformData,
                            DALabels: tmpDALabels
                          });
                        } }  
                      />
                    </td>
                  </tr>
                )
              })
            }
          </tbody>
        </Table>
      </Form.Group>
      <Button _type="submit" className="odisea-form-button-submit" onClick={() => {submitForm();}}>Guardar</Button>
    </Form>
  );

  const footerSection = (
    <Form>
      <Form.Group className="admin-content-group">
        <Form.Label className="admin-content-form-label">Contenido</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          defaultValue={ mainConfig?.footerContent && mainConfig.footerContent }
          onChange={ (e) => {
            setMainConfigformData({
              ...mainConfigformData,
              footerContent: e.target.value
            });
          } } 
        />
      </Form.Group>
      <Button _type="submit" className="odisea-form-button-submit" onClick={() => {submitForm();}}>Guardar</Button>

    </Form>
  );

  const linksSection = (
    <>
    <Form>
    <Form.Group className="admin-content-group">
      <Form.Label className="admin-content-form-label">Enlaces de banner</Form.Label>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Título</th>
            <th>URL</th>
            <th>Operaciones</th>
          </tr>
        </thead>
        <tbody>
          {
            bannerLinks.map((item, itemId) => {
              return (
                <tr>
                  <td>{itemId + 1}</td>
                  <td>
                    <Form.Control
                      placeholder="Titulo"
                      defaultValue={ item.title }
                      value={ bannerLinksformData[item.id]?.title ? bannerLinksformData[item.id].title : item.title}
                      onChange={ (e) => {
                        setBannerLinksformData({
                          ...bannerLinksformData,
                          [item.id] : {
                            'title': e.target.value,
                            'url': bannerLinksformData[item.id] ? bannerLinksformData[item.id]['url'] : item.url
                          }
                        });
                      } }  
                    />
                  </td>
                  <td>
                    <Form.Control
                      placeholder="URL"
                      defaultValue={ item.url }
                      value={ bannerLinksformData[item.id]?.url ? bannerLinksformData[item.id].url : item.url}
                      onChange={ (e) => {
                        setBannerLinksformData({
                          ...bannerLinksformData,
                          [item.id] : {
                            'title': bannerLinksformData[item.id] ? bannerLinksformData[item.id]['title'] : item.title,
                            'url': e.target.value
                          }
                        });
                      } }  
                    />
                  </td>
                  <td><Button _type="submit" className="admin-add-item-button" onClick={() => {saveBannerLink(item.id);}}>Guardar Link</Button> | <Button _type="submit" className="admin-delete-item-button" onClick={() => {handleDeleteBannerLink(item.id)}}>Eliminar</Button> </td>
                </tr>
              )
            })
          }
        </tbody>
      </Table>
      <Button _type="submit" className="odisea-form-button-submit" onClick={() => {handleAddBannerLinks()}}>Agregar Link</Button>
      </Form.Group>

      <Form.Group className="admin-content-group">
      <Form.Label className="admin-content-form-label">Enlaces de RRSS</Form.Label>
      {/* JSON.stringify() */}
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Título</th>
            <th>URL</th>
            <th>Operaciones</th>
          </tr>
        </thead>
        <tbody>
          {
            footerLinks.map((item, itemId) => {
              return (
                <tr>
                  <td>{itemId + 1}</td>
                  <td> { item.title } </td>
                  <td>
                    <Form.Control
                      placeholder="Titulo"
                      defaultValue={ item.url }
                      onChange={ (e) => {
                        setFooterLinksformData({
                          ...footerLinksformData,
                          [item.id] : {
                            'title': footerLinksformData[item.id] ? footerLinksformData[item.id]['title'] : item.title,
                            'url': e.target.value,
                          }
                        });
                      } }  
                    />
                  </td>
                  <td><Button _type="submit" className="admin-add-item-button" onClick={() => {saveFooterLink(item.id);}}>Guardar Link</Button></td>
                </tr>
              )
            })
          }
        </tbody>
      </Table>
      </Form.Group>
    </Form>
    </>
  );

  const configDBSSection = (
    <>
    <Form>
    <Form.Group className="admin-content-group">
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Nombre</th>
            <th>Etiqueta</th>
            <th>Módulos</th>
            <th>Operaciones</th>
          </tr>
        </thead>
        <tbody>
          {
            mainConfigformData?.dbAlias && mainConfigformData.dbAlias.map((item, itemId) => {
              return (
                <tr>
                  <td>{itemId + 1}</td>
                  <td>
                    <Form.Control
                      placeholder="Nombre"
                      defaultValue={ item.name }
                      value={ mainConfigformData.dbAlias[itemId]?.title ? mainConfigformData.dbAlias[itemId].name : item.name}
                      onChange={ (e) => {

                        let tempDbAlias = mainConfigformData.dbAlias;
                        tempDbAlias[itemId]['name'] = e.target.value;

                        setMainConfigformData({
                          ...mainConfigformData,
                          dbAlias: tempDbAlias
                        });
                      } }
                    />
                  </td>
                  <td>
                    <Form.Control
                      placeholder="Etiqueta"
                      defaultValue={ item.label }
                      value={ mainConfigformData.dbAlias[itemId]?.label ? mainConfigformData.dbAlias[itemId].label : item.label}
                      onChange={ (e) => {

                        let tempDbAlias = mainConfigformData.dbAlias;
                        tempDbAlias[itemId]['label'] = e.target.value;

                        setMainConfigformData({
                          ...mainConfigformData,
                          dbAlias: tempDbAlias
                        });
                      } }
                    />
                  </td>
                  <td>
                    {modulesList.map((moduleItem, moduleItemId) => 
                      <Form.Check
                        id= { moduleItemId }
                        type = 'switch'
                        label={ moduleItem.label }
                        value={ item[moduleItem.value] }
                        defaultChecked = {item[moduleItem.value]}
                        checked = {item[moduleItem.value]}
                        onChange={ (e) => {
                          let tempDbAlias = mainConfigformData.dbAlias;
                          tempDbAlias[itemId][moduleItem.value] = !tempDbAlias[itemId][moduleItem.value];
  
                          setMainConfigformData({
                            ...mainConfigformData,
                            dbAlias: tempDbAlias
                          });
                        }}
                      />
                    )}

                  </td>
                  <td><Button _type="submit" className="admin-delete-item-button" onClick={() => {handleDeleteDB(itemId)}}>Eliminar</Button> </td>
                </tr>
              )
            })
          }
        </tbody>
      </Table>
      <Button _type="submit" className="odisea-form-button-submit" onClick={() => {handleAddDB()}}>Agregar Nueva Base de Datos</Button>
      <Button _type="submit" className="odisea-form-button-submit" onClick={() => {submitForm();}} style={{marginLeft: '20px'}}>Guardar configuración</Button>
      </Form.Group>
    </Form>
    </>
  );

  return (
    <Container fluid>
      <p>{/*JSON.stringify(mainConfigformData)*/}</p>
      <Row>
          <Col xs={2} >
            <Sidebar />
          </Col>
          <Col xs={10} className="admin-content">
            <ToastConfirmation showToaster={showToaster} setShowToaster={ setShowToaster } message={ 'Contenido guardado con éxito!' }/>
            <Card>
              <Card.Header> Contenido principal </Card.Header>
              <Card.Body>{ formContent }</Card.Body>
            </Card>

            <Card>
              <Card.Header> Bases de datos </Card.Header>
              <Card.Body>{ configDBSSection }</Card.Body>
            </Card>

            <Card>
              <Card.Header> Divisiones Administrativas </Card.Header>
              <Card.Body>{ DASection }</Card.Body>
            </Card>
            <Card>
              <Card.Header> Contenido de footer </Card.Header>
              <Card.Body>{ footerSection }</Card.Body>
            </Card>
            <Card>
              <Card.Header> Enlaces </Card.Header>
              <Card.Body>{ linksSection }</Card.Body>
            </Card>
          </Col> 
      </Row>
    </Container>
  )
}
